import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormGroup, UntypedFormGroup } from "@angular/forms";
import { EditableGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/editable-grid/editable-grid.component";
import { ReportKindInfo } from "projects/sepidz-web-framework-data-grid/src/lib/report-kind";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { InvStatusKind, RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { GridFilter, LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { GoodsUnit } from "../../../models/goods.model";
import { ProductConversionDetail, ProductConversionHeader } from "../../../models/product-conversion-header.model";
import { ProductConversionStandardDetail } from "../../../models/product-conversion-standard-header.model";

@Component({
  selector: "ngx-product-conversion-form",
  templateUrl: "./product-conversion-form.component.html",
  styleUrls: ["./product-conversion-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductConversionFormComponent extends BaseFormComponent<ProductConversionHeader> {
  isloading: boolean = false;
  reportKinds = ReportKindInfo.reportKinds;
  ProductConversionDetailColumns: form_control[] = [];
  DefaultValues: Dictionary = [];
  @ViewChild("grid") public grid: EditableGridComponent;
  constructor(
    _tabsservice: TabularService,
    __id: FormContainerModel,
    private lookupservice: LookupService,
    private splashFormService: SplashFormService,
    protected selectorService: SelectorService,
    private datatransfer: Datatransfer,
    protected cd: ChangeDetectorRef
  ) {
    super(selectorService, cd);
    this._id = __id;
    this.currentrow = this.datatransfer?.currentrow;
    if (this.datatransfer?.apiName) this.apiName = this.datatransfer?.apiName;
    if (this.datatransfer?.label) this.label = this.datatransfer?.label;
    if (this.datatransfer?.areaName) this.areaName = this.datatransfer?.areaName;

    this.tabsservice = _tabsservice;
  }
  get readableStandardInfo() {
    return this.model?.WastesVoucherId || this.model.IncrementVoucherId || this.model?.DecrementVoucherId;
  }
  get VoucherCreatable() {
    return (
      !this.isNewRow &&
      this.model?.ProductConversionDetails &&
      this.model?.ProductConversionDetails.length > 0 &&
      !this.model?.IncrementVoucherId &&
      !this.model?.DecrementVoucherId &&
      !this.model?.WastesVoucherId
    );
  }
  get VoucherDeleteable() {
    return this.model?.IncrementVoucherId || this.model?.DecrementVoucherId || this.model?.WastesVoucherId;
  }

  async ngOnInit() {
    this.DefaultValues["ProductConversionHeaderId"] = 0;
    this.apiName = "ProductConversionHeader";
    this.label = this.translate("ClientApp.Pages.PageMenu.ProductConversionTitle");
    this.reportName = "ProductConversionHeader";
    this.pathPreFix = "INV";
    super.ngOnInit();
  }
  setAvragePurchaseByWarehouse() {
    let filters: GridFilter[] = [];
    let GoodsIds: Number[] = [];
    if (!this.formGroup?.get("GoodsId")?.value) return;
    GoodsIds.push(this.formGroup.get("GoodsId").value);
    filters.push({
      Filed: "VoucherDate",
      Value: this.formGroup?.get("ProductConversionDate")?.value,
      Skip: 0,
      Take: 0,
      Operator: "gte",
      Type: "F",
      Logic: "and",
    });
    filters.push({
      Filed: "WarehouseId",
      Value: this.formGroup?.get("WarehouseId")?.value,
      Skip: 0,
      Take: 0,
      Operator: "gte",
      Type: "F",
      Logic: "and",
    });
    filters.push({
      Filed: "FiscalYearId",
      Value: this.formGroup?.get("FiscalYearId")?.value,
      Skip: 0,
      Take: 0,
      Operator: "gte",
      Type: "F",
      Logic: "and",
    });
    filters.push({
      Filed: "CurrentBranchId",
      Value: this.formGroup?.get("BranchId")?.value,
      Skip: 0,
      Take: 0,
      Operator: "gte",
      Type: "F",
      Logic: "and",
    });
    filters.push({ Filed: "GoodsIds", Value: GoodsIds, Skip: 0, Take: 0, Operator: "gte", Type: "F", Logic: "and" });
    this.httpCommonService
      .create("Goods/GetAvragePurchaseByWarehouse", filters)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x: any[]) => {
        if (x) {
          this.model.UnitPrice = x.filter((f) => f.GoodsId === this.formGroup?.get("GoodsId")?.value).getSumWithKey("AvrageUnitPrice");
          this.setValue("UnitPrice", this.model.UnitPrice);
        }
      });
  }
  setGoodsProductConversionFormPrice() {
    let filters: GridFilter[] = [];
    let GoodsIds: Number[] = [];
    if (!this.formGroup?.get("GoodsId")?.value) return;
    GoodsIds.push(this.formGroup.get("GoodsId").value);
    filters.push({
      Filed: "VoucherDate",
      Value: this.formGroup?.get("ProductConversionDate")?.value,
      Skip: 0,
      Take: 0,
      Operator: "gte",
      Type: "F",
      Logic: "and",
    });
    filters.push({
      Filed: "WarehouseId",
      Value: this.formGroup?.get("WarehouseId")?.value,
      Skip: 0,
      Take: 0,
      Operator: "gte",
      Type: "F",
      Logic: "and",
    });
    filters.push({
      Filed: "FiscalYearId",
      Value: this.formGroup?.get("FiscalYearId")?.value,
      Skip: 0,
      Take: 0,
      Operator: "gte",
      Type: "F",
      Logic: "and",
    });
    filters.push({
      Filed: "CurrentBranchId",
      Value: this.formGroup?.get("BranchId")?.value,
      Skip: 0,
      Take: 0,
      Operator: "gte",
      Type: "F",
      Logic: "and",
    });
    filters.push({ Filed: "GoodsIds", Value: GoodsIds, Skip: 0, Take: 0, Operator: "gte", Type: "F", Logic: "and" });
    this.httpCommonService
      .create("InventoryReview/GetGoodsLastUnitPrice", filters)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (x && x.length > 0) {
          this.model.UnitPrice = x.getSumWithKey("DefaultUnitPrice");
          this.setValue("UnitPrice", this.model.UnitPrice);
        } else this.setAvragePurchaseByWarehouse();
      });
  }
  onformGroupValueChanges(changedData: { newValue: any; oldValue: any; field: string; formGroup: FormGroup }) {
    if (changedData.field === "BaseAmount") {
      let AmountRate: number = changedData.formGroup.get("AmountRate").value ?? 0;
      let BaseAmount: number = changedData.formGroup.get("BaseAmount").value ?? 0;
      let PriceRate: number = changedData.formGroup.get("PriceRate").value ?? 0;
      let BaseUnitPrice: number =
        changedData.formGroup.get("BaseUnitPrice").value ?? this.model.Price / (this.model.Amount - (this.model.WastesAmount ?? 0));
      if (AmountRate <= 0 && BaseAmount > 0)
        changedData.formGroup
          .get("AmountRate")
          .setValue((BaseAmount / (this.formGroup.get("Amount").value - (this.formGroup.get("WastesAmount").value ?? 0))) * 100);

      if (
        !changedData.formGroup.get("PriceRate").value ||
        changedData.formGroup.get("PriceRate").value === 0 ||
        changedData.formGroup.get("PriceRate").value !== (Price / this.model.Price) * 100
      ) {
        if (PriceRate !== (Price / this.model.Price) * 100) {
          var Price = Math.round(BaseUnitPrice * BaseAmount);
          changedData.formGroup.get("PriceRate").setValue((Price / this.model.Price) * 100);
        }
      }
    }
  }
  onChange($event) {
    if (this.isNewRow) {
      if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Goods/GetPagining")) {
        this.model.GoodsTitle = $event.data.Title;
        this.model.GoodsCode = $event.data.Code;
        this.model.GoodsId = $event.data.Id;
        this.model.GoodsUnitId = $event.data.UnitId;
        this.model.GoodsUnitTitle = $event.data.UnitTitle;
        this.model.GoodsUnitRatio = $event.data.DefaultUnitRatio;
        this.setValue("GoodsUnitRatio", this.model.GoodsUnitRatio);
        this.setValue("GoodsUnitId", this.model.GoodsUnitId);
        this.setValue("GoodsUnitTitle", this.model.GoodsUnitTitle);
        this.setGoodsUnit();
        this.setGoodsProductConversionFormPrice();
        if (this.grid?.formGroup) {
          this.grid.formGroup.get("BaseAmount").valueChanges.subscribe((s) => {
            if (s) {
              let AmountRate: number = this.grid?.formGroup?.get("AmountRate").value ?? 0;
              let BaseAmount: number = this.grid?.formGroup?.get("BaseAmount").value ?? 0;
              let PriceRate: number = this.grid?.formGroup?.get("PriceRate").value ?? 0;
              let BaseUnitPrice: number = this.grid?.formGroup?.get("BaseUnitPrice").value;
              if (AmountRate <= 0 && BaseAmount > 0)
                this.grid?.formGroup
                  ?.get("AmountRate")
                  .setValue((BaseAmount / (this.formGroup.get("Amount").value - (this.formGroup.get("WastesAmount").value ?? 0))) * 100);

              if (!this.grid?.formGroup?.get("PriceRate").value || this.grid?.formGroup?.get("PriceRate").value === 0) {
                if (PriceRate == 0) {
                  var Price = Math.round(BaseUnitPrice * BaseAmount);
                  this.grid?.formGroup?.get("PriceRate").setValue((Price / this.model.Price) * 100);
                }
              }
            }
          });
        }
      }
      if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Goods/ReadGoodsUnitLookUp")) {
        this.model.GoodsUnitTitle = $event.data.UnitTitle;
        this.model.GoodsUnitRatio = $event.data.Ratio;
        this.setValue("GoodsUnitRatio", this.model.GoodsUnitRatio);
        this.setValue("GoodsUnitTitle", this.model.GoodsUnitTitle);
        this.setGoodsUnit();
      }
    }
  }
  setGoodsUnit() {
    this.httpCommonService
      .getList("Goods/ReadGoodsUnitLookUp/" + this.model.GoodsId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (!(x as GoodsUnit[]).some((u) => u.UnitId === this.model.GoodsUnitId))
          (x as GoodsUnit[]).push({
            GoodsId: this.model.GoodsId,
            UnitId: this.model.GoodsUnitId,
            Ratio: 1,
            UnitTitle: this.model.GoodsUnitTitle,
            IsDefault: false,
            Id: 0,
          });
        this.selectorService.setDataList("GoodsUnitId", x as []);
      });
  }
  setdefault() {
    if (this.model?.GoodsId) this.setGoodsUnit();
    if (!this.model.ProductConversionDate) this.model.ProductConversionDate = new Date();
    if (!this.model.ProductConversionDetails) this.model.ProductConversionDetails = [];
    if (!this.model.FiscalYearId && this.accountService.authService.currentFiscalYear) {
      this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
      this.model.Year = this.accountService.authService.currentFiscalYear.Year;
    } else if (!this.model.FiscalYearId) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.model.FiscalYearId = x.Id;
          this.model.Year = x.Year;
          this.setValue("FiscalYearId", x.Id);
          this.setValue("Year", x.Year);
        }
      });
    }
    if (!this.model.BranchId) this.model.BranchId = this.accountService.authService.currentBranchId;
    if (!this.model.StatusKindId) {
      this.lookupservice
        .getLookupbyCode("INV", "StatusKind", InvStatusKind.Registered)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            this.model.StatusKindId = x.Id;
            this.model.StatusKindCode = x.Code;
            this.model.StatusKindTitle = x.Title;
            this.setValue("StatusKindId", this.model.StatusKindId);
            this.setValue("StatusKindCode", this.model.StatusKindCode);
            this.setValue("StatusKindTitle", this.model.StatusKindTitle);
          }
        });
    }

    if (this.grid && this.model && this.model?.ProductConversionDetails && this.model?.ProductConversionDetails?.length > 0) {
      this.model.ProductConversionDetails.forEach((x) => (x.State = RowState.NoChange));
      this.grid.dataList = this.model.ProductConversionDetails;
      this.cd.markForCheck();
      if (!this.isNewRow && this.grid.dataList.some((x) => x.Id == 0)) {
        setTimeout(async () => {
          await this.ngOnInit();
        }, 50);
      }
    }
  }
  setDetailValue(x: UntypedFormGroup) {
    if (x != null) {
      let BaseAmount: number = x.get("BaseAmount").value;
      if (BaseAmount > 0) x.get("BaseMainAmount").setValue(BaseAmount * this.model.GoodsUnitRatio);
      let Amount: number = x.get("Amount").value;
      let AmountRate: number = x.get("AmountRate").value;
      let GoodsUnitRatio: number = x.get("GoodsUnitRatio").value;
      let PriceRate: number = x.get("PriceRate").value;
      if (Amount > 0 || AmountRate > 0) {
        if (AmountRate && AmountRate > 0) {
          BaseAmount = (AmountRate * (this.formGroup.get("Amount").value - (this.formGroup.get("WastesAmount").value ?? 0))) / 100;
          x.get("BaseAmount").setValue(BaseAmount);
        }
        x.get("MainAmount").setValue(Amount * GoodsUnitRatio);
        if (Amount && Amount > 0) {
          x.get("UnitPrice").setValue((x.get("PriceRate").value * this.model.Price) / 100 / Amount);
          x.get("Price").setValue(Math.round(Amount * x.get("UnitPrice").value));
        }
      }
    }
  }
  setAmountValue() {
    if (this.model.ProductConversionDetails == null) return;
    this.model.MainAmount = this.formGroup?.get("MainAmount")?.value;
    this.model.Amount = this.formGroup?.get("Amount")?.value;
    this.model.GoodsUnitRatio = this.formGroup?.get("GoodsUnitRatio")?.value;
    this.model.UnitPrice = this.formGroup?.get("UnitPrice")?.value;
    if (this.model.MainAmount != this.model.Amount * this.model.GoodsUnitRatio) this.model.MainAmount = this.model.Amount * this.model.GoodsUnitRatio;
    if (this.model.Price != this.model.UnitPrice * this.model.Amount) this.model.Price = this.model.UnitPrice * this.model.Amount;
    if (this.model.ProductConversionDetails.length > 0 && this.model.Price > 0 && this.model.Amount > 0) {
      this.model.ProductConversionDetails.forEach((item) => {
        if (
          item.BaseUnitPrice !=
          this.model.Price /
            (this.model.Amount - (this.model.WastesAmount ?? 0) <= 0 ? 1 : this.model.Amount - (this.formGroup?.get("WastesAmount").value ?? 0))
        ) {
          item.BaseUnitPrice = this.model.Price / (this.model.Amount - (this.model.WastesAmount ?? 0));
          if (this.grid?.formGroup) this.grid.formGroup.get("BaseUnitPrice").setValue(item.BaseUnitPrice);
        }
        if (item.UnitPrice != (item.BaseUnitPrice * item.BaseAmount) / (item.Amount <= 0 ? 1 : item.Amount) && item.Amount > 0) {
          if (item.PriceRate > 0) {
            item.UnitPrice = (item.PriceRate * this.model.Price) / 100 / item.Amount;
          } else item.UnitPrice = (item.BaseUnitPrice * item.BaseAmount) / item.Amount;
          if (this.grid?.formGroup) this.grid.formGroup.get("UnitPrice").setValue(item.UnitPrice);
        }
        if (item.Price != item.UnitPrice * item.Amount) {
          item.Price = item.UnitPrice * item.Amount;
          if (this.grid?.formGroup) this.grid.formGroup.get("Price").setValue(item.Price);
        }
        if (item.MainAmount != item.Amount * item.GoodsUnitRatio) {
          item.MainAmount = item.Amount * item.GoodsUnitRatio;
          if (this.grid?.formGroup) this.grid.formGroup.get("MainAmount").setValue(item.MainAmount);
        }

        if (item.PriceRate == 0) {
          item.PriceRate = (item.Price / this.model.Price) * 100;
          if (this.grid?.formGroup) this.grid.formGroup.get("PriceRate").setValue(item.PriceRate);
        }
        if (item.AmountRate == 0) {
          item.PriceRate = (item.Price / this.model.Price) * 100;
          if (this.grid?.formGroup)
            this.grid.formGroup.get("AmountRate").setValue((item.BaseAmount / (this.model.Amount - (this.model.WastesAmount ?? 0))) * 100);
        }
      });
    }
    this.setValue("Price", this.model.Price);
    this.setValue("MainAmount", this.model.MainAmount);
  }
  addControl() {
    this.formGroup?.get("Amount").valueChanges.subscribe((s) => {
      if (s) this.setAmountValue();
    });
    this.formGroup?.get("UnitPrice").valueChanges.subscribe((s) => {
      if (s) this.setAmountValue();
    });
    this.cd.markForCheck();
  }
  focusFunction() {
    if (this.model?.GoodsId) this.setGoodsUnit();
  }
  valueChanges(event) {
    if (event.DefaultUnitId) {
      this.httpCommonService
        .getList("Goods/ReadGoodsUnitLookUp/" + event.Id)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.Amount = this.formGroup.get("Amount").value ?? 0;
          this.model.WastesAmount = this.formGroup.get("WastesAmount").value ?? 0;
          if (!(x as GoodsUnit[]).some((u) => u.UnitId === event.UnitId))
            (x as GoodsUnit[]).push({ GoodsId: event.Id, UnitId: event.UnitId, Ratio: 1, UnitTitle: event.UnitTitle, IsDefault: false, Id: 0 });
          this.selectorService.setDataList("Goods/ReadGoodsUnitLookUp", x as []);
          this.grid.formGroup?.get("GoodsUnitRatio").setValue(event.DefaultUnitRatio ?? 1);
          if (this.grid.formGroup?.get("BaseUnitPrice"))
            this.grid.formGroup.get("BaseUnitPrice").setValue(this.model.Price / (this.model.Amount - (this.model.WastesAmount ?? 0)));
        });
    }
    if (event instanceof UntypedFormGroup) this.setDetailValue(event);
  }
  setColumnAttribute() {
    super.setColumnAttribute();
    this.orignalColumns.forEach((x) => {
      if (x.name !== "StatusKindTitle" && x.name !== "Price") x.disabled = this.VoucherDeleteable ? true : false;
    });
    this.ProductConversionDetailColumns = this.getDetailControlModels("ProductConversionDetails");

    this.columns.forEach((x) => ((x.isFloat = null), (x.userClass = null), (x.columnNumber = null)));
    this.cd.markForCheck();
  }
  setMaxCode() {
    this.httpCommonService
      .getItem(`${this.apiName}/GetMaxCode`, this.formGroup?.get("FiscalYearId")?.value)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (!this.model) this.model = <ProductConversionHeader>{};
        if (data) {
          this.model.Number = data as number;
        }
        this.setFormGroup(this.model);
      });
  }
  async createVoucher() {
    this.splashFormService.openDialog("", "در حال صدور اسناد");
    await this.httpCommonService
      .create(this.apiName + "/CreateVoucher", this.model)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (row) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog("اسناد با موفقیت صادر شد.", "");
          this.saveSuccessHelper(row);
          this.ngOnInit();
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(`خطا در صدور سند${Utilities.getHttpResponseMessage(error)}`, "خطا");
        }
      );
  }
  async deleteVoucher() {
    this.splashFormService.openDialog("", "در حال حذف اسناد");
    await this.httpCommonService
      .create(this.apiName + "/DeleteVucher", this.model)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (row) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog("اسناد با موفقیت حذف شد.", "");
          this.saveSuccessHelper(row);
          this.ngOnInit();
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(` خطا در حذف سند ${Utilities.getHttpResponseMessage(error)}`, "خطا");
        }
      );
  }
  getStandardInfo() {
    this.model.WastesAmount = this.formGroup?.get("WastesAmount")?.value;
    if (!this.formGroup?.get("GoodsId")?.value) this.sts.showDialog("کالای تبدیل انتخاب نشده است.", "دریافت اطلاعات استاندارد");
    if (!this.formGroup?.get("Amount")?.value || !this.formGroup?.get("Price")?.value)
      this.sts.showDialog("مقدار یا فی وارد نشده است.", "دریافت اطلاعات استاندارد");
    this.httpCommonService
      .getList(`ProductConversionStandardHeader/GetStandardInfo/${this.formGroup.get("GoodsId").value}`)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (x: ProductConversionStandardDetail[]) => {
          if (x && x.length > 0) {
            x.forEach((item) => {
              if (!this.model.ProductConversionDetails.some((x) => x.GoodsId === item.GoodsId)) {
                let entity = <ProductConversionDetail>{};
                entity.GoodsId = item.GoodsId;
                entity.AmountRate = item.AmountRate;
                entity.PriceRate = item.PriceRate;
                entity.GoodsCode = item.GoodsCode;
                entity.GoodsTitle = item.GoodsTitle;
                entity.GoodsUnitId = item.GoodsUnitId;
                entity.GoodsUnitTitle = item.GoodsUnitTitle;
                entity.GoodsUnitRatio = item.GoodsUnitRatio;
                entity.BaseUnitPrice = this.model.Price / (this.model.Amount - (this.model.WastesAmount ?? 0));
                entity.BaseAmount = ((this.model.Amount - (this.model.WastesAmount ?? 0)) * entity.AmountRate) / 100;
                entity.BaseMainAmount = entity.BaseAmount * entity.GoodsUnitRatio;
                this.model.ProductConversionDetails.push(entity);
              }
            });
            this.cd.markForCheck();
            if (this.grid) {
              this.grid.dataList = this.model.ProductConversionDetails;
              this.grid.refreshform();
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }
  isCloseable() {
    this.selectorService.submitted$.next(false);
    this.formGroup?.markAsUntouched();
    this.currentrow = this.model;
    return false;
  }
}
